var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"flex-grow-0 border-t border-gray-200 px-4 py-4 sm:px-6 flex justify-end"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }